export default __webpack_public_path__ + "static/media/FeedbackUI.ca1daf2c.png";